(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.directives')
		.directive('header', Header)

	/** @ngInject */
	function Header(PATHS) {
		function HeaderController($rootScope, $state, $scope, CouponService, UserService, DATA_EVENTS) {
			const vm = this;
			let typingTimer;

			vm.openSearch = () => {
				if ($state.current.name != "app.home")
					$state.go("app.home");


				if (vm.searchTerm.length) {
					vm.searchTerm = "";
					CouponService.setSearchTerm(vm.searchTerm);
					$rootScope.$broadcast(DATA_EVENTS.OPEN_SEARCH);

					return
				}
				else
					vm.showSearchBar = !vm.showSearchBar;

				if (vm.showSearchBar == false)
					$rootScope.$broadcast(DATA_EVENTS.CLOSE_SEARCH);
				else
					$rootScope.$broadcast(DATA_EVENTS.OPEN_SEARCH);
			}

			vm.doSearch = () => {
				clearTimeout(typingTimer);

				typingTimer = setTimeout(() => {
					if (vm.searchTerm.length) {
						CouponService.setSearchTerm(vm.searchTerm);
						$rootScope.$broadcast(DATA_EVENTS.DO_SEARCH);
					} else {
						vm.searchTerm = "";
						CouponService.setSearchTerm(vm.searchTerm);
						$rootScope.$broadcast(DATA_EVENTS.OPEN_SEARCH);
					}
				}, 500);
			}

			init();

			function init() {
				vm.userData = UserService.getUser();
				vm.showSearchBar = false;
				vm.searchTerm = "";
			}
		}

		return {
			bindToController: true,
			controller: HeaderController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`,
			scope: {}
		}
	}
}());